'use client';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import getLocale from '@/libraries/getters/get-locale';
// TODO: load on demand, maybe split into each app directory? https://day.js.org/docs/en/i18n/loading-into-browser
import 'dayjs/locale/da';
import 'dayjs/locale/en';
import 'dayjs/locale/sv';
import parseTimePlugin from './parse-zone';

const useDateFormatter = (extend?: dayjs.PluginFunc<unknown>[]) => {
  const locale = getLocale();

  dayjs.extend(utc);
  extend?.forEach(plugin => dayjs.extend(plugin));
  // Dayjs doesn't keep timezone information when parsing a date string, so we need to use a custom plugin.
  dayjs.extend(parseTimePlugin);
  dayjs.extend(weekOfYear);
  dayjs.locale(locale);

  // Return the dayjs instance with the plugins and locale set up.
  return {
    dateFormatter: dayjs.parseZone,
    dayjs,
  };
};

export default useDateFormatter;
